import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryDateComponent } from './history-date/history-date.component';
import { HistoryHeaderComponent } from './history-header/history-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { HistoryBodyComponent } from './history-body/history-body.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [CommonModule, TranslateModule, SharedModule],
  exports: [HistoryDateComponent, HistoryHeaderComponent, HistoryBodyComponent],
  declarations: [HistoryDateComponent, HistoryHeaderComponent, HistoryBodyComponent]
})
export class ContactHistoryModule {}
